import { IcosCSSValuePipe } from './css-value'

export {
  IcosCSSValuePipe,
}

